import React from "react";
import "./index.css";
import { FaGraduationCap } from "react-icons/fa";
import { RiComputerFill } from "react-icons/ri";
import { FaPen } from "react-icons/fa";
import { FaBookOpen } from "react-icons/fa";
import { FaMedal ,FaTrophy} from "react-icons/fa";
import { TbBulbFilled } from "react-icons/tb";
import { BsCalculatorFill } from "react-icons/bs";
import { PiStudentFill } from "react-icons/pi";
import { FaUniversity } from "react-icons/fa";
import { HiPencilSquare } from "react-icons/hi2";

const Icons = () => {
  return (
    <>
      <div className="icons-container">
        <FaBookOpen className="icon-styles" />
        <FaGraduationCap className="icon-styles" />
        <FaPen className="icon-styles" />
        <RiComputerFill className="icon-styles" />
        <FaMedal className="icon-styles" />
        <FaTrophy className="icon-styles" />
        <TbBulbFilled className="icon-styles" />
        <BsCalculatorFill className="icon-styles" />
        <PiStudentFill className="icon-styles" />
        <FaUniversity className="icon-styles" />
        <HiPencilSquare className="icon-styles" />
        <RiComputerFill className="icon-styles" />
      </div>
    </>
  );
};

export default Icons;
